import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon, Dropdown } from 'semantic-ui-react';
import { Logo, Button as Btn, ModalEditPassword, TimerSessionCheck } from 'components';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './AdminHeader.css';
const cx = classNames.bind(styles);

class AdminHeader extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isAuth,
      isModal,
      isClicked,
      menuOpen,
      onToggleAdminMenu,
      onLogout,
      handleGoService,
      editPasswordData
    } = this.props;
    const toggleButtonIcon = menuOpen ? 'angle double left' : 'angle double down';
    let curLanguage = '한국어';
    if (localStorage.getItem('language') === 'ko') {
      curLanguage = '한국어';
    } else if (localStorage.getItem('language') === 'ja') {
      curLanguage = '日本語';
    } else if (localStorage.getItem('language') === 'en') {
      curLanguage = 'English';
    }
    if (commonVar.isJapan === 1) {
      if (localStorage.getItem('language') === 'en') {
        curLanguage = 'English';
      } else {
        curLanguage = '日本語';
      }
    }

    return (
      <div className={cx('admin-header')}>
        <div className={cx('left-area')}>
          <Btn buttonColor="#f6f6f6" className={cx('bt-menu', 'bt-style-gleam')} onClick={onToggleAdminMenu}>
            <Icon name={toggleButtonIcon} />
            {defineMessages(formatMessage({ id: 'AdminHeader_1', defaultMessage: '설정' }))}
          </Btn>
        </div>
        <div className={cx('center-area')}>
          <Logo color="white" />
        </div>
        <div className={cx('right-area')}>
          <TimerSessionCheck />
          <Btn buttonColor="#f6f6f6" className={cx('bt-service', 'bt-style-gleam')} onClick={handleGoService}>
            <Icon name="home" />
            {defineMessages(formatMessage({ id: 'AdminHeader_2', defaultMessage: '서비스' }))}
          </Btn>
          {/* {commonVar.isJapan !== 1 && ( */}
          <Dropdown className="icon select-language" button floating labeled icon="world" text={curLanguage}>
            <Dropdown.Menu>
              {commonVar.isJapan !== 1 && (
                <Dropdown.Item
                  text="한국어"
                  onClick={() => {
                    localStorage.setItem('language', 'ko');
                    window.location.reload();
                  }}
                />
              )}
              <Dropdown.Item
                text="日本語"
                onClick={() => {
                  localStorage.setItem('language', 'ja');
                  window.location.reload();
                }}
              />
              {commonVar.isEng === 1 && (
                <Dropdown.Item
                  text="English"
                  onClick={() => {
                    localStorage.setItem('language', 'en');
                    window.location.reload();
                  }}
                />
              )}
            </Dropdown.Menu>
          </Dropdown>
          {/* )} */}
          <Btn
            buttonColor="#f6f6f6"
            className={cx('bt-service', 'bt-style-gleam')}
            onClick={() => {
              editPasswordData.onToggleModal('adminPassword');
            }}>
            {defineMessages(formatMessage({ id: 'AdminHeader_3', defaultMessage: '비밀번호 변경' }))}
          </Btn>
          {isModal === 'adminPassword' && (
            <ModalEditPassword isClicked={isClicked} editPasswordData={editPasswordData} />
          )}
          <Btn buttonColor="#f6f6f6" className={cx('bt-logout', 'bt-style-gleam')} onClick={onLogout}>
            Logout
          </Btn>
        </div>
      </div>
    );
  }
}

AdminHeader.propTypes = {
  isAuth: PropTypes.number,
  onToggleMenu: PropTypes.func,
  onLogout: PropTypes.func
};

AdminHeader.defaultProps = {
  isAuth: 0
};

export default injectIntl(AdminHeader);



// WEBPACK FOOTER //
// ./src/script/components/admin/AdminHeader.js